/** A record panel's block heading: a hairline, then a muted caption ("↻ From Ventrata ·
 *  read-only, owned by the booking system", "System · derived and provenance"). The
 *  Editable / vendor / System split it draws IS the read-only distinction — no lock icon
 *  on every field (DESIGN.md §5). */
import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

/** `rule={false}` drops the hairline — for a panel's first block (an order's Bookings and
 *  Money panels have no editable fields above it). */
export function BlockRule({
  icon,
  title,
  note,
  rule = true,
  children,
}: {
  icon?: ReactNode;
  title: string;
  note?: string;
  rule?: boolean;
  children: ReactNode;
}) {
  return (
    <Box sx={{ ...(rule ? { borderTop: 1, borderColor: 'divider', pt: 1.25 } : {}), display: 'grid', gap: 0.75 }}>
      <Typography
        variant="caption"
        component="h3"
        color="text.secondary"
        sx={{ m: 0, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        {icon}
        {title}
        {note && (
          <Box component="span" sx={{ fontWeight: 400 }}>
            · {note}
          </Box>
        )}
      </Typography>
      {children}
    </Box>
  );
}
